import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import { Pane } from "components/ui"
import AssignmentType from "./AssignmentType"

const Assignments = () => {
  const { registerable: registration } = useContext(RegisterableContext)

  return (
    <Pane marginTop={3} marginBottom={1}>
      <Pane.Header>
        <Pane.Title>Assignments</Pane.Title>
      </Pane.Header>
      <Pane.Body>
        {registration.event.assignmentTypes.map(assignmentType => (
          <AssignmentType
            key={assignmentType.id}
            attendees={registration.attendees}
            assignmentType={assignmentType}
            assignmentAreas={registration.event.assignmentAreas}
          />
        ))}
      </Pane.Body>
    </Pane>
  )
}

export default Assignments
